export default __webpack_public_path__ + "static/media/a' glanadh.3590542d.mp3";